// extracted by mini-css-extract-plugin
module.exports =  {"copy":"Y4tNYVQVCCRCAoKa7Htv","code":"AMKHZdV82DU7Qr0YVxDA"};